<div class="candidate-activity-container">
  <div class="activity-header">
    <mat-button-toggle-group [value]="selectedPeriod" (change)="onPeriodChange($event)">
      <mat-button-toggle value="7d">7d</mat-button-toggle>
      <mat-button-toggle value="30d">30d</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Loading state -->
  <div *ngIf="isLoading" class="loading-state">
    <mat-spinner diameter="32"></mat-spinner>
  </div>

  <!-- Activity timeline -->
  <div class="activity-timeline" *ngIf="!isLoading && activities.length > 0">
    <div class="timeline-item" *ngFor="let activity of activities; let last = last">
      <div class="timeline-marker">
        <mat-icon [style.color]="getActivityColor(activity.activityType)">
          {{ getActivityIcon(activity.activityType) }}
        </mat-icon>
      </div>
      <div class="timeline-connector" *ngIf="!last"></div>
      <div class="timeline-content">
        <span class="timestamp">{{ activity.createdAt | talentmarketDatePipe }}</span>
        <span class="summary">{{ getSummaryKey(activity.activityType) | translate:getSummaryParams(activity) }}</span>
        <span class="detail" *ngIf="getActivityDetail(activity)">
          {{ getActivityDetail(activity) }}
        </span>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!isLoading && activities.length === 0" class="empty-state">
    <mat-icon>inbox</mat-icon>
    <p>{{ 'activityFeed.noActivities' | translate }}</p>
  </div>
</div>
